// AWS Cognito Configuration for MammoTrials
// Using UCF User Pool with environment-based configuration

function isTemplatePlaceholder(value) {
  if (!value) return true;
  const trimmed = value.trim();
  if (!trimmed) return true;

  const normalized = trimmed.toLowerCase();
  return (
    normalized.includes('xxxxxxxx')
    || normalized.includes('your-api-id')
    || normalized === 'replace-me'
    || normalized === 'tbd'
  );
}

const userPoolId = process.env.REACT_APP_USER_POOL_ID?.trim();
const userPoolClientId = process.env.REACT_APP_USER_POOL_CLIENT_ID?.trim();
const identityPoolId = process.env.REACT_APP_IDENTITY_POOL_ID?.trim();

if (
  !userPoolId
  || !userPoolClientId
  || isTemplatePlaceholder(userPoolId)
  || isTemplatePlaceholder(userPoolClientId)
) {
  throw new Error(
    'Invalid Cognito configuration. Set real values for REACT_APP_USER_POOL_ID and REACT_APP_USER_POOL_CLIENT_ID in .env.development.local.'
  );
}

export function getCognitoConfig() {
  return {
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        ...(identityPoolId ? { identityPoolId } : {}),
        loginWith: {
          email: true,
        },
        signUpVerificationMethod: 'code',
        userAttributes: {
          email: {
            required: true,
          },
          given_name: {
            required: true,
          },
          family_name: {
            required: true,
          },
        },
        passwordFormat: {
          minLength: 8,
          requireLowercase: true,
          requireUppercase: false,
          requireNumbers: true,
          requireSpecialCharacters: false,
        },
      },
    },
  };
}

export const cognitoConfig = getCognitoConfig();

// User roles supported by MammoTrials
export const USER_ROLES = {
  PATIENT: 'patient',
  CLINICIAN: 'clinician', 
  COMMUNITY: 'community',
  RESEARCHER: 'researcher',
  ADMIN: 'admin'
};

// Portal mapping for each role
export const PORTAL_ROUTES = {
  [USER_ROLES.PATIENT]: '/patient',
  [USER_ROLES.CLINICIAN]: '/clinician',
  [USER_ROLES.COMMUNITY]: '/community', 
  [USER_ROLES.RESEARCHER]: '/researcher',
  [USER_ROLES.ADMIN]: '/admin'
};

export default cognitoConfig;